import { render } from "./DhPagination.vue?vue&type=template&id=29e9ef00"
import script from "./DhPagination.vue?vue&type=script&lang=ts"
export * from "./DhPagination.vue?vue&type=script&lang=ts"
script.render = render

export default script